import styled from "@emotion/styled"
import { BaseFormControl } from "style/form"

export const TextFieldWrapper = styled.div`
  ${BaseFormControl}
`
